export const errorsDictionary = {
  unknownError: "Noma'lum xato",
}
